export enum ChartDataAs {
  GuideViews = 'GuideClicks',
  WebsiteViews = 'WebsiteClicks',
  FacebookViews = 'FacebookViews',
  InstagramViews = 'InstagramViews',
  TwitterViews = 'TwitterViews',
  Aggregation = 'Aggregation',
  Separate = 'Separate'
}
